import { useSharableState, view } from '@esui/core';
import { VSTack } from '@esui/core/layout/index.js';
import { DemoPage, Section } from '../@demo/utils.js';
import { Textfield } from './index.js';

export const [TextfieldDemo] = view('textfield-demo', {
  template() {
    const text = useSharableState('');

    return DemoPage(
      Section(
        'Filled',
        Textfield('Standard', text),
        Textfield('Standard', text).icon('event'),
        Textfield('Standard', text).iconTrailing('delete')
      ),

      Section(
        'Outlined',
        Textfield('Outlined', text).outlined(),
        Textfield('Outlined', text).outlined().icon('event'),
        Textfield('Outlined', text).outlined().iconTrailing('delete')
      ),
      VSTack(Textfield('Standard', text))
    );
  },
});
